import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------

LoginGuard.propTypes = {
  children: PropTypes.node
}

export default function LoginGuard({ children }) {
  const { isAuthenticated, isWebVersion, logout, role } = useAuth();

  if ( isWebVersion() ) {
    return <Navigate to="/" />;
  }

  // Logout if user is logged in as Guest
  if ( isAuthenticated ) {
    if (role === 'GUEST') {
      logout();

      return <>{children}</>;
    }

    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
